export default __webpack_public_path__ + "static/media/product-image-hover-21.893ccae4.jpg";